import { cardAnatomy } from "@chakra-ui/anatomy";
import { createMultiStyleConfigHelpers } from "@chakra-ui/react";

const { definePartsStyle, defineMultiStyleConfig } =
  createMultiStyleConfigHelpers(cardAnatomy.keys);

const baseStyle = definePartsStyle({
  container: {
    borderRadius: "10px",
    borderStyle: "solid",
    boxShadow: "0 5px 10px 0 rgba(0, 0, 0, 0.1)",
  },
});

const primaryStyle = definePartsStyle(({ colorScheme }) => ({
  container: {
    background: `linear-gradient(45deg, #3E4451, #3B3F45 45%)`,
    color: "white",
    borderRadius: "10px",
    borderWidth: "1px",
    borderColor: "#5B5F61",
    padding: "10px",
  },
}));

const dataStyle = definePartsStyle({
  body: {
    padding: "10px",
  },
});

const cardTheme = defineMultiStyleConfig({
  baseStyle,
  defaultProps: {
    colorScheme: "blue",
  },
  variants: {
    primary: primaryStyle,
    data: dataStyle,
  },
});

export default cardTheme;
